import ResetPasswordEmail from './reset-password-email';

export default ResetPasswordEmail;
